import { Component, Input } from '@angular/core';

import { IPaperLayoutData } from 'editing-tool/src/app/shared/components/paper/paper-layout-data';

@Component({
    selector: 'et-paper-layout',
    templateUrl: './paper-layout.component.html',
    standalone: false
})
export class PaperLayoutComponent {

    @Input()
    public data: IPaperLayoutData;
}
